import { render, staticRenderFns } from "./DormRoomEditForm.vue?vue&type=template&id=23d42dc5&scoped=true&"
import script from "./DormRoomEditForm.vue?vue&type=script&lang=js&"
export * from "./DormRoomEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomEditForm.vue?vue&type=style&index=0&id=23d42dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d42dc5",
  null
  
)

export default component.exports